import { Box, Flex, Grid, Image, Text, Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody, useDisclosure, Divider, Drawer, DrawerOverlay, DrawerContent, DrawerCloseButton, DrawerHeader, DrawerBody, Button, Spacer, InputGroup, InputLeftElement, Input, PinInput, PinInputField } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import MyDiv from "./employeeDocuments.style";
import DocumentIcon from "../../../../../assets/images/DocumentIcon.svg";
import { EmployeeDocumentModel } from "../../../../../models/employeeDocuments";
import { AlertCard, CustomButton, CustomToast } from "../../../../../components";
import EmployeeDocumentDrawer from "../EmployeeDocumentDrawer";
import { useFetch } from "../../../../../hooks/useFetch";
import UploadLogo from "../../../../../assets/images/UploadLogo.svg";
import { DocumentState, props } from "./model";
import { useAuth } from "../../../../../hooks/useAuth";


interface ICodeOfConduct {
  id: number;
  company_Id: number;
  branch_Id: number;
  company_Name: string;
  branch_Name: string;
  filePath: string;
}

const EmployeeDocuments = ({ employeeId }: props) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [selectedFile, setSelectedFile] = useState<string>("");
  const [selectedDocName, setSelectedDocName] = useState<string>("");
  const [DrawerOpen, setDrawerOpen] = useState(false);
  const [documents, setDocuments] = useState<EmployeeDocumentModel[]>([]);
  const { addToast } = CustomToast();
  const { fetchApi } = useFetch(addToast);
  const { hasPermission, loginObj } = useAuth();
  const [uploadOpen, setUploadOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedDoc, setSelectedDoc] = useState<any>([]);
  const [document, setDocument] = useState<DocumentState>({ docType: "", docName: "", fileName: "", file: null, filePath: "" });
  const [alertConfig, setAlertConfig] = useState<{ description: string; colorScheme: string; onConfirm: () => void; } | null>(null);
  const [sendOtp, setSendOtp] = useState(false);
  const [otp, setOtp] = useState("");
  const [otpbox, setOtpbox] = useState(false);
  const [verifying, setVerifying] = useState(false);
  const [pendingDoc, setPendingDoc] = useState<{ file: string; name: string; purpose: string } | null>(null);
  const [verifiedDocs, setVerifiedDocs] = useState<Set<string>>(new Set());
  const loggedInEmpId = loginObj?.employeeId;
  const canViewOthers = hasPermission("Employee", "showCriticalField");
  const isOwnProfile = loggedInEmpId === employeeId;
  const [purpose, setPurpose] = useState("");
  const [codeOfConduct, setCodeOfConduct] = useState<ICodeOfConduct[]>([]);

  const handleAddedDoc = () => {
    setDrawerOpen(false);
  }
  const renderFields = (doc: EmployeeDocumentModel) => {
    switch (doc.categoryName) {

      case "Identity":
        return (
          <>
            <Flex justify="space-between">
              <Text className="font-poppins text_sm text_medium" >Document ID</Text>
              <Text className="font-poppins text_sm text_medium" >{doc.document_Number || "N/A"}</Text>
            </Flex>
            <Divider />

            <Flex justify="space-between">
              <Text className="font-poppins text_sm text_medium">Document Name</Text>
              <Text className="font-poppins text_sm text_medium">{doc.documentName || "N/A"}</Text>
            </Flex>
            <Divider />

            {doc.expire_Date && (
              <>
                <Flex justify="space-between">
                  <Text className="font-poppins text_sm text_medium">Document Exp. Date</Text>
                  <Text className="font-poppins text_sm text_medium">{doc.expire_Date || "N/A"}</Text>
                </Flex>
                <Divider />
              </>
            )}
          </>
        );

      case "Education":
        return (
          <>
            <Flex justify="space-between">
              <Text className="font-poppins text_sm text_medium">Title</Text>
              <Text className="font-poppins text_sm text_medium">{doc.title || "N/A"}</Text>
            </Flex>
            <Divider />

            <Flex justify="space-between">
              <Text className="font-poppins text_sm text_medium">Qualification</Text>
              <Text className="font-poppins text_sm text_medium">{doc.qulification || "N/A"}</Text>
            </Flex>
            <Divider />

            <Flex justify="space-between">
              <Text className="font-poppins text_sm text_medium">University</Text>
              <Text className="font-poppins text_sm text_medium">{doc.university || "N/A"}</Text>
            </Flex>
            <Divider />
          </>
        );

      case "Education Document":
        return (
          <>
            <Flex justify="space-between">
              <Text className="font-poppins text_sm text_medium"> Title</Text>
              <Text className="font-poppins text_sm text_medium">{doc.title || "N/A"}</Text>
            </Flex>
            <Divider />

            <Flex justify="space-between">
              <Text className="font-poppins text_sm text_medium"> Qualification</Text>
              <Text className="font-poppins text_sm text_medium"> {doc.qulification || "N/A"}</Text>
            </Flex>
            <Divider />

            <Flex justify="space-between">
              <Text className="font-poppins text_sm text_medium"> University</Text>
              <Text className="font-poppins text_sm text_medium"> {doc.university || "N/A"}</Text>
            </Flex>
            <Divider />
          </>
        );

      case "Finanicial Document":
      case "photo":
      case "Passport photo":
        return (
          <>
            <Flex justify="space-between">
              <Text className="font-poppins text_sm text_medium">Document Name</Text>
              <Text className="font-poppins text_sm text_medium">{doc.documentName || ""}</Text>
            </Flex>
            <Divider />
          </>
        );

      default:
        return null;
    }
  };


  const openDocumentWithSecurity = (file: string, name: string, purpose: string) => {
    if (isOwnProfile && verifiedDocs.has(file) || canViewOthers) {
      handleViewDocument(file, name);
      return;
    }
    setPendingDoc({ file, name, purpose });
    setAlertConfig({

      description: "For security purposes, a verification code is required to access full details. Proceed to receive the code?",
      colorScheme: "green",
      onConfirm: () => sendOtpforIdentity(purpose)
    });
  };



  const handleViewDocument = async (file: string, docName: string) => {
    try {
      const response = await fetchApi("Hrlense_Employee/getDocImg", "GET", null, `fileName=${file}&employeeId=${employeeId}`);
      if (response) {
        const { contentType, base64 } = response;
        const fileUrl = `data:${contentType};base64,${base64}`;
        setSelectedFile(fileUrl);
        setSelectedDocName(docName);
        onOpen();
      }
    } catch (err) {
      console.error("Error fetching document:", err);
    }
  };

  const handleViewCodeOfConduct = async (filePath: string) => {
    try {
      const response = await fetchApi("Hrlense_CodeofConduct/GetCodeOfConductFile", "GET", null, `fileName=${filePath}`);
      if (response) {
        const { contentType, base64 } = response;
        const fileUrl = `data:${contentType};base64,${base64}`;
        setSelectedFile(fileUrl);
        setSelectedDocName(filePath);
        onOpen();
      }
    } catch (err) {
      addToast({
        message: "Failed to load document", status: "error",
      });
    }
  };
  const loadDocuments = async () => {
    const response = await fetchApi("Hrlense_Employee/EmpDocument", "GET", null, `employeeId=${employeeId}`)
    if (response) {
      setDocuments(response);
    }
  };

  useEffect(() => {
    loadDocuments();
    loadCodeOfConduct();
  }, [employeeId]);

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      const allowedTypes = ["application/pdf", "image/png", "image/jpeg", "image/jpg",];
      const maxSize = 5 * 1024 * 1024;
      if (!allowedTypes.includes(file.type)) {
        e.target.value = "";
        setDocument({ ...document, file: null, fileName: "" });
        addToast({ message: "Only PDF or image files (PNG/JPG) are allowed.", status: "error", });
        return;
      }
      if (file.size > maxSize) {
        e.target.value = "";
        setDocument({ ...document, file: null, fileName: "" });
        addToast({ message: "File size must be less than 5MB.", status: "error", });
        return;
      }
      setDocument({ ...document, file, fileName: file.name });
    }
  };

  const handleNextClick = async () => {
    try {
      setLoading(true);
      const formDataPayload = new FormData()
      if (!document.file) {
        addToast({ message: "File upload is required.", status: "warning" });
        return;
      }

      if (document.file) formDataPayload.append("file", document.file);
      formDataPayload.append("id", selectedDoc.id);
      const res = await fetchApi("Hrlense_Employee/EmpDocUpload", "PUT", formDataPayload, null, "Document uploaded Successfully", true);
      if (res) {
        setUploadOpen(false);
        setSelectedDoc([]);
        setDocument({ docType: "", docName: "", fileName: "", file: null, filePath: "" })
        setSelectedDocName("");
        loadDocuments();
      }
    } catch (error) {
      addToast({ message: `Error uploading document: ${error instanceof Error ? error.message : "Unknown error"}`, status: "error" });
    } finally {
      setLoading(false);
    }
  };

  const sendOtpforIdentity = async (purposeValue: string) => {
    setSendOtp(true);
    setPurpose(purposeValue);
    const res = await fetchApi("Tds_Slab/otpforsecure", "POST", { employee_Id: employeeId, purpose: purposeValue }, null, "");
    if (res) {
      setSendOtp(false); setOtpbox(true);
      addToast({ message: res.message, status: "success" });
    }
    if (!res) { setSendOtp(false); onClose(); }
  };

  const verifyOtp = async () => {
    if (otp.length !== 6) {
      addToast({ message: "Enter 6 digit Verification Code", status: "error" });
      return;
    }
    if (!pendingDoc) return;
    setVerifying(true);
    const res = await fetchApi("Tds_Slab/verifyotp", "POST", { purpose: purpose, otp }
    );
    if (res) {
      setVerifying(false);
      setOtpbox(false);
      setVerifiedDocs(prev => new Set(prev).add(pendingDoc.file));
      if (pendingDoc) {
        setVerifiedDocs(prev => new Set(prev).add(pendingDoc.file));
        handleViewDocument(pendingDoc.file, pendingDoc.name);
        setPendingDoc(null);
      }
      setOtp("");
      addToast({ message: res.message, status: "success" });
    }
    if (!res) {
      setVerifying(false);

      setOtp("");
    }
  };

  const loadCodeOfConduct = async () => {
    const response = await fetchApi("Hrlense_CodeofConduct/GetCodeOfConductEmp", "GET", null, `employeeId=${employeeId}`);
    if (response) {
      setCodeOfConduct(response);
    }
  };



  return (
    <MyDiv>
      <Grid templateColumns={{ base: "1fr", md: "repeat(2, 1fr)" }} gap={6}>
        {documents?.map((doc, index) => (
          <Box key={index} className="card" boxShadow="sm">

            <Box bg="#f9f9f9" borderRadius="md" p={2}>
              <Flex align="center" gap={2}>
                <Image src={DocumentIcon} alt="icon" />
                <Text className="font-poppins font_dark text_sm text_medium">{doc.categoryName}</Text>
              </Flex>
            </Box>
            <Box display="flex" flexDirection="column" gap={3} pl={1} p={3}>
              {renderFields(doc)}
            </Box>
            <Flex justify="flex-end" p={3}>
              {doc.file ? (
                <>
                  <Flex gap={2}>
                    <CustomButton title="View Document" onClick={() => openDocumentWithSecurity(doc.file, doc.documentName, doc.documentName)} className="btn_theme font-poppins text_sm text_medium" />
                    {(hasPermission('Employee', "UpdateEmployeesDocument") || (hasPermission('Employee', 'UpdateOwnDocument') && isOwnProfile)) &&
                      (
                        <CustomButton title="Update Document" className="btn_theme font-poppins text_sm text_medium" onClick={() => { setUploadOpen(true); setSelectedDoc(doc); }} />
                      )}
                  </Flex>
                </>
              ) : (
                <Button className="btn_theme font-poppins text_sm text_medium mr-2" onClick={() => { setUploadOpen(true); setSelectedDoc(doc); }}>Upload Document</Button>
              )}
            </Flex>
          </Box>
        ))}
        {codeOfConduct.length > 0 &&
          codeOfConduct.map((item, index) => (
            <Box key={index} className="card" boxShadow="sm">
              <Box bg="#f9f9f9" borderRadius="md" p={2}>
                <Flex align="center" gap={2}>
                  <Image src={DocumentIcon} alt="icon" />

                  <Text className="font-poppins font_dark text_sm text_medium">
                    Code Of Conduct
                  </Text>
                </Flex>
              </Box>

              <Flex justify="flex-end" p={3}>
                <CustomButton
                  title="View Document"
                  className="btn_theme font-poppins text_sm text_medium"
                  onClick={() =>
                    handleViewCodeOfConduct(item.filePath)
                  }
                />
              </Flex>
            </Box>
          ))}
      </Grid>

      <Flex justify="flex-end" py={3}>
        {(hasPermission("Employee", "AddEmployeesDocument") || (hasPermission("Employee", "AddOwnDocument") && isOwnProfile)) &&
          (
            <CustomButton title="Add New Document" className="btn_theme font-poppins text_sm text_medium" onClick={() => setDrawerOpen(true)} />
          )}
      </Flex>
      <AlertCard title="Access Confirmation" isLoading={sendOtp} isOpen={!!alertConfig} onClose={() => setAlertConfig(null)} onConfirm={() => { if (alertConfig?.onConfirm) alertConfig.onConfirm(); setAlertConfig(null); }} description={alertConfig?.description || ''} colorScheme={alertConfig?.colorScheme || 'red'}
      />
      {/* Model for OTP*/}
      <Modal isOpen={otpbox} onClose={() => setOtpbox(false)} closeOnOverlayClick={false} closeOnEsc={false} isCentered>
        <ModalOverlay />
        <ModalContent borderRadius="12px" p={6}>
          <ModalCloseButton />

          <ModalBody textAlign="center">
            <Text fontSize="xl" fontWeight="600" mb={2}> OTP Verification </Text>
            <Text color="gray.500" mb={6}>
              Please enter the 6-digit verification code sent to your registered official email address.
            </Text>

            <Flex justify="center" gap={3} mb={6}>
              <PinInput otp value={otp} onChange={setOtp}>
                {[...Array(6)].map((_, i) => (
                  <PinInputField key={i} />
                ))}
              </PinInput>
            </Flex>
            <Button isDisabled={verifying} width="100%" colorScheme="green" onClick={verifyOtp} >
              Verify Code
            </Button>
          </ModalBody>
        </ModalContent>
      </Modal>

      <Modal isOpen={isOpen} onClose={onClose} size="6xl" isCentered>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader alignSelf="center" className="font-poppins text_medium text_xl" color="rgba(102, 102, 102, 1)">{selectedDocName}</ModalHeader>
          <ModalCloseButton />
          <Divider />
          <ModalBody display="flex" justifyContent="center" alignItems="center">
            {selectedFile && (
              selectedFile.includes("application/pdf") ? (
                <iframe src={selectedFile} style={{ width: "100%", height: "80vh", border: "none" }} title="PDF Preview" />
              ) : (
                <Image src={selectedFile} alt={selectedDocName} maxH="80vh" objectFit="contain" />
              )
            )}
          </ModalBody>
        </ModalContent>
      </Modal>

      <Drawer isOpen={uploadOpen} placement="right" onClose={() => { setUploadOpen(false); setSelectedDocName(""); }}>
        <DrawerOverlay />
        <DrawerContent maxW="400px">
          <DrawerCloseButton />
          <DrawerHeader className="font-poppins text_medium text_xl" color="rgba(102, 102, 102, 1)">{selectedDoc.documentName}</DrawerHeader>
          <Divider />
          <DrawerBody>
            <Flex align="center" mb={4}>
              <InputGroup maxWidth={"200px"}>
                <InputLeftElement width="auto" px={2}>
                  <Button as="label" htmlFor={`file-upload`} size="sm" colorScheme="gray" leftIcon={<Image src={UploadLogo} />} cursor="pointer" borderRadius="md" w="100%" className="font-poppins text_sm text_regular">Upload</Button>
                  <input id="file-upload" type="file" accept="application/pdf,image/png,image/jpeg,image/jpg" hidden onChange={handleFileChange} />
                </InputLeftElement>
                <Input className="font-poppins text_sm text_regular" placeholder="No file chosen" value={document.fileName} isReadOnly pl="120px" />
              </InputGroup>
            </Flex>
            <Box mt="auto" borderTop="1px solid #eee" pt={3}>
              <Flex justify="flex-end">
                <CustomButton title={loading ? "Uploading..." : "Upload Document"} className="btn_theme font-poppins text_sm text_medium" onClick={handleNextClick} isDisabled={loading} />
              </Flex>
            </Box>
          </DrawerBody>
        </DrawerContent>
      </Drawer>

      <Drawer isOpen={DrawerOpen} placement="right" onClose={() => setDrawerOpen(false)} size="sm">
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader> Add New Document </DrawerHeader>
          <DrawerBody display="flex" flexDirection="column" justifyContent="space-between" height="100%">
            <EmployeeDocumentDrawer employeeId={employeeId} onDocumentAdded={loadDocuments} onClose={handleAddedDoc} />
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </MyDiv>
  );
};

export default EmployeeDocuments;